import { useKeyboard } from '@react-aria/interactions'
import { forwardRef, InputHTMLAttributes } from 'react'
import { useObjectRef } from 'utils/useObjectRef'
import Styles from './WorkflowBuilderItem.module.scss'
import cx from 'classnames'
import { mergeProps } from '@react-aria/utils'

export const Description = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>((props, fRef) => {
  const ref = useObjectRef(fRef)

  const { keyboardProps } = useKeyboard({
    onKeyDown: ({ key }) => {
      if (key === 'Enter') {
        ref.current?.blur()
      }
    },
  })

  return (
    <input
      ref={ref}
      type="text"
      placeholder="Add description..."
      className={cx(Styles.textField, Styles.description)}
      {...mergeProps(props, keyboardProps)}
    />
  )
})
